import React, { forwardRef } from "react";
import themeStyles from "../utils/themeStyles";
import { withErrorBoundary } from "../boundaries/withErrorBoundary";
import GeneralErrorBoundary from "../boundaries/GeneralErrorBoundary";
import { useVsiAppContext } from "../stores/VsiApp";

const CustomDateInput = forwardRef(({ value, onClick }, ref) => {
  const { theme } = useVsiAppContext();
  return (
    <button
      className="square border border-1"
      style={{
        background: themeStyles[theme].sideBgColor,
        color: themeStyles[theme].textColor,
        padding: 4,
        borderRadius: 5
      }}
      onClick={onClick}
      ref={ref}>
      {value}
    </button>

  )
});

export default withErrorBoundary(CustomDateInput, GeneralErrorBoundary);
